export default __webpack_public_path__ + "static/media/bosch_icon.a90cbe98.woff2";